import type { Resource } from '../../';
export const forms_field_useShippingAddressForBilling: Resource = {"default":"Use Shipping Address for Billing"};
